import { SEND_FEEDBACK } from '../actions/feedbackActions';

const initialState = {
  sendingFeedback: false,
};

export function feedback(state = initialState, action) {  
  switch (action.type) {
    case SEND_FEEDBACK.pending:
      return {
        ...state,
        sendingFeedback: true,
        lastError: undefined,
        feedbackResponse: undefined,
      };
    case SEND_FEEDBACK.fulfilled:
      return {
        ...state,
        sendingFeedback: false,
        lastError: undefined,
        feedbackResponse: action.payload,
      };

    case SEND_FEEDBACK.rejected:
      return {
        ...state,
        sendingFeedback: false,
        lastError: action.payload,
        feedbackResponse: undefined,
      };
    default:
      return state;
  }
}
